export default __webpack_public_path__ + "static/media/logo.daf5f996.jpg";